import Axios from 'axios';


// user

export const logout = () => Axios.post('/logout');

export const getUserData = () => Axios.get('/api/users/getUserData');

export const getAllLicenses = () => Axios.get('/api/licenses');

export const getAllProducts = () => Axios.get('/api/products');

export const changePassword = (password, newPassword) => Axios.post('/api/users/changePassword',
		{
			password: password,
			newPassword: newPassword,
		});


// trainers

export const addTrainer = trainer => Axios.post('/api/trainers/createTrainer', trainer);

export const getTrainers = () => Axios.get('/api/trainers/trainers');

export const getTrainer = trainer => Axios.get('/api/trainers/getTrainer',
		{
			params: {
				trainer: trainer,
			},
		});

export const updateTrainer = (trainer, upd) => Axios.post('/api/trainers/updateTrainer', upd,
		{
			params: {
				trainer: trainer,
			},
		});

export const setTrainerEnabled = (trainer, enabled) => Axios.post('/api/trainers/setTrainerEnabled', null,
	{
		params: {
			trainer: trainer,
			enabled: enabled,
		},
	});


// clients

export const addClient = (trainer, client) => Axios.post('/api/clients/addClient', client,
		{
			params: {
				trainer: trainer,
			},
		});

export const getClients = trainer => Axios.get('/api/clients/clients',
		{
			params: {
				trainer: trainer,
			},
		});

export const updateClient = (trainer, client, upd) => Axios.post('/api/clients/updateClient', upd,
		{
			params: {
				trainer: trainer,
				client: client,
			},
		});

export const removeClient = (trainer, client) => Axios.post('/api/clients/removeClient', null,
		{
			params: {
				trainer: trainer,
				client: client,
			},
		});

export const issueQuestionnaire = (client, type) => Axios.post(`/api/clients/${client}/issueQuestionnaire/${type}`,
	null, null);

export const checkForQuestionnaire = (client, questionnaireType) =>
	Axios.post(`/api/clients/${client}/checkForQuestionnaire/${questionnaireType}`, null, null);

export const deleteNewestQuestionnaire = (client, questionnaireType) =>
	Axios.post(`/api/clients/${client}/deleteNewestQuestionnaire/${questionnaireType}`, null, null);


// analyses

export const createAnalysis = (client, date, analysis) =>
		Axios.post(`/api/clients/${client}/analyses/${analysis}`, null,
				{
					params: {
						date: date,
					},
				});


// admin

export const setTrainerPassword = (id, password) => Axios.post('/api/users/setTrainerPassword',
	{
		password: password,
	},
	{
		params: {
			trainer: id,
		}
	}
);
